import React, { useState } from 'react'
import Datepicker from "react-tailwindcss-datepicker";

const Payroll = (props) => {
  const [tab, setTab] = useState('da')
  const [value, setValue] = useState({
    startDate: null,
    endDate: null
  });

  const [state, setState] = useState({
    year: new Date().getFullYear(),
    month: '',
    employeID: '',
  });

  const handleValueChange = (newValue) => {
    console.log("newValue:", newValue.target.value);
    setState({
      ...state,
      year: newValue.target.value
    });
  }

  var yearList = [];
  for (var i = 0; i < 20; i++) {
    yearList.push({
    id: new Date().getFullYear() -5 + i,
    year: new Date().getFullYear() -5 + i
  });
  }

  const rawData = {
		category: [
			{
				id: 1,
				name: 'Loading....',
			},
		],
		monthList: [
			{ id: 1, name: 'January' },
			{ id: 2, name: 'February' },
			{ id: 3, name: 'March' },
			{ id: 4, name: 'April' },
			{ id: 5, name: 'May' },
			{ id: 6, name: 'June' },
			{ id: 7, name: 'July' },
			{ id: 8, name: 'August' },
			{ id: 9, name: 'September' },
			{ id: 10, name: 'October' },
			{ id: 11, name: 'November' },
			{ id: 12, name: 'December' },
		]
	};

  return (
    <div className='w-full h-screen grid-cols-1 bg-white sm:grid-cols-2'>
      <div className='w-full h-20 bg-real-white'>
        <div className='flex items-center h-full px-4'>
          <a href='/home'>
            <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/arrow-left.svg"} className='justify-start w-10 py-1' />
          </a>
          <p className='px-4'>Payroll</p>
        </div>
      </div>

      <div className='w-full h-screen bg-white'>

        <div className='grid grid-cols-1'>
          <div className='w-1/2 p-4'>
            <select id="countries" value={state.year} onChange={(e) => handleValueChange(e)} className="block w-full p-4 text-sm text-gray-900 border rounded-lg bg-bg-primary border-bg-primary focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500">
              {yearList?.map(item => (
                 <option key={item.id} value={item.id}>{item.year}</option>
              ) ) }
            </select>

          </div>
          <div className='pb-4 bg-white'>
          {rawData.monthList?.map((item, i, array) => (

                 <a href='/detail-payroll' key={item.id}>
                 <div className="flex p-4 mx-4 mt-4 rounded-lg bg-real-white">
                   <img alt='logo_home' src={process.env.PUBLIC_URL + "/assets/img/icon-file.svg"} className='justify-start w-8 py-1' />
                   <div className="px-2">
                     <p className='py-1 text-base font-bold'>{item.name}</p>
                     <p className='py-1 text-base'>26 {item.name === 'January' ? 'December ' + (parseInt(state.year)-1) : array[i-1].name + " " + state.year } - 25 {item.name} {state.year}</p>
                   </div>
                 </div>
               </a>
              ) ) }
              </div>
          


        </div>


      </div>


    </div >

  )
}

export default Payroll